import { registerHandler } from "@utils/pixels/handler";
import { FB_ELTV13_PIXEL } from "@utils/services/ConversionTracker";
import { fireFacebookCapi } from "@utils/services/FacebookCapiApi";

export default function registerHandlers() {
  registerHandler("purchase", ({ fbCapiParams }) => {
    fireFacebookCapi(FB_ELTV13_PIXEL, "Purchase", fbCapiParams);
  });
}
